import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, AlertTriangle, ArrowLeft } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user && user.role === "admin") nav("/admin", { replace: true });
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.success) nav("/admin", { replace: true });
    else setError(res.error);
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center relative overflow-hidden" style={{ padding: "48px 24px" }} data-testid="admin-login-page">
      <div className="absolute inset-0 nx-hero-grid opacity-50"></div>
      <div
        className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-15"
        style={{ background: "radial-gradient(circle, #00C8FF 0%, transparent 70%)" }}
      ></div>

      <div className="relative w-full" style={{ maxWidth: 460 }}>
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-mist hover:text-cyan"
          style={{ marginBottom: 24, fontSize: 15 }}
          data-testid="admin-back-home"
        >
          <ArrowLeft size={16} strokeWidth={1.75} /> Retour au site
        </Link>

        <div className="bg-white rounded-[10px]" style={{ padding: 40, boxShadow: "0 20px 40px -20px rgba(0,0,0,0.4)" }}>
          <div className="flex justify-center" style={{ marginBottom: 24 }}>
            <div style={{ background: "#050505", padding: 16, borderRadius: 10 }}>
              <Logo variant="full" height={44} asLink={false} />
            </div>
          </div>
          <div className="text-center" style={{ marginBottom: 32 }}>
            <span className="nx-overline">Espace admin</span>
            <h3 style={{ marginTop: 12, marginBottom: 8 }}>Connexion sécurisée</h3>
            <p style={{ fontSize: 15, marginBottom: 0 }}>Accédez aux demandes de devis reçues.</p>
          </div>

          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 20 }}>
            <div>
              <label className="nx-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="nx-input"
                data-testid="admin-login-email"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="nx-label">Mot de passe</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="nx-input"
                data-testid="admin-login-password"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div
                className="flex items-start gap-3 p-4 rounded-[10px] border border-red-200 bg-red-50 text-red-800"
                style={{ fontSize: 15 }}
                data-testid="admin-login-error"
              >
                <AlertTriangle size={20} strokeWidth={1.75} className="shrink-0 mt-0.5" />
                <span>{error}</span>
              </div>
            )}
            <button
              type="submit"
              disabled={loading}
              className="nx-btn nx-btn-primary w-full disabled:opacity-60"
              style={{ marginTop: 8 }}
              data-testid="admin-login-submit"
            >
              {loading ? "Connexion..." : "Se connecter"}
              <LogIn size={18} strokeWidth={2} />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
